const ActivityLogItem = ({ logger, date, message }) => {
  return (
    <div className="activity-log-item flex flex-row justify-between items-center border-[#F7F8FF] border-b py-3 px-2 hover:bg-[#F7F8FF] transition-all">
      <div className="flex flex-row items-center gap-x-[10px]">
        <img src="/assets/images/patient-icon-default.svg" alt="icon" />
        <div>
          <p className="text-[#1C1C1C] text-[16px] font-semibold">
            {logger}
          </p>
          <p className="text-[#676767] text-[11px] font-[400]">
            {message}
          </p>
        </div>
      </div>
      <p className="text-[#BEC0CA] text-[14px]">{date}</p>
    </div>
  );
};

export default ActivityLogItem;
